<template>
  <form id="reset-questions" class="std-form">
    <h2>Forgot username or password?</h2>
    <p class="info-text">
      If at least three of your answers to the questions below match what we
      have on file, we'll send you an email which will allow you to reset your
      username and/or password.
    </p>
    <div class="form-group">
      <label for="their-question">1. {{ question }}</label>
      <input v-model="question1" type="text" id="their-question" />
    </div>
    <div class="form-group">
      <label for="license-no"
        >2. What are the last 4 digits of your professional license?</label
      >
      <input v-model="question2" type="text" id="license-no" />
    </div>
    <div class="form-group">
      <label for="npi">3. What is your NPI?</label>
      <input v-model="question3" type="text" id="npi" />
    </div>
    <div class="form-group">
      <label for="ssn-no"
        >4. What are the last 4 digits of your (SSN/EIN)?</label
      >
      <input v-model="question4" type="text" id="ssn-no" />
    </div>
    <div class="form-group">
      <label for="office-zipcode"
        >5. What is the zip code of your primary office?</label
      >
      <input v-model="question5" type="text" id="office-zipcode" />
    </div>
    <div class="form-group">
      <label for>
        6. Which of the following insurance companies have you not entered in
        PSYBooks?
      </label>
      <div class="insurance-info">
        <div class="form-group">
          <input
            id="question-one"
            type="radio"
            name="insurance"
            value="0"
            @change="selected6 = 0"
          />
          <label for="question-one">
            {{ insuranceQuestions[0].businessName }}
          </label>
        </div>
        <div class="form-group">
          <input
            id="question-two"
            type="radio"
            name="insurance"
            value="1"
            @change="selected6 = 1"
          />
          <label for="question-two">
            {{ insuranceQuestions[1].businessName }}
          </label>
        </div>
        <div class="form-group">
          <input
            id="question-three"
            type="radio"
            name="insurance"
            value="2"
            @change="selected6 = 2"
          />
          <label for="question-three"
            >I've entered both of these companies</label
          >

          <br />
        </div>
        <div class="form-group">
          <input
            id="question-four"
            type="radio"
            name="insurance"
            value="3"
            @change="selected6 = 3"
          />
          <label for="question-four"
            >I have not entered any insurance companies in PSYBooks</label
          >
        </div>
      </div>
    </div>
    <button
      @click.stop.prevent="submitForm"
      type="submit"
      class="btn btn-secondary"
    >
      Submit
    </button>
  </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      question1: "",
      question2: "",
      question3: "",
      question4: "",
      question5: "",
      selected6: -1
    };
  },
  computed: {
    ...mapGetters("forgotPassword", {
      question: "getQuestion",
      insuranceQuestions: "getInsuranceQuestions",
      getUserId: "getUserId"
    })
  },
  methods: {
    ...mapActions("forgotPassword", {
      matchAnswer: "matchAnswer"
    }),
    submitForm() {
      this.matchAnswer({
        answer1: this.question1,
        answer2: this.question2,
        answer3: this.question3,
        answer4: this.question4,
        answer5: this.question5,
        answer6: this.selected6
      });
    }
  },
  watch: {
    getUserId(value) {
      if (value === 0) {
        this.$router.push("/");
      }
    }
  }
};
</script>

<style scoped>
.insurance-info {
  margin: 20px 0 40px;
  color: #878787;
}

.form-group input[type="radio"]:checked,
.form-group input[type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}
.form-group input[type="radio"]:checked + label,
.form-group input[type="radio"]:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #666;
}
.form-group input[type="radio"]:checked + label:before,
.form-group input[type="radio"]:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 1px solid #ddd;
  border-radius: 100%;
  background: #fff;
}
.form-group input[type="radio"]:checked + label:after,
.form-group input[type="radio"]:not(:checked) + label:after {
  content: "";
  width: 10px;
  height: 10px;
  background: #e46700;
  position: absolute;
  top: 5px;
  left: 5px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.form-group input[type="radio"]:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
}
.form-group input[type="radio"]:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}
</style>
